import {
    MapCoordinate,
    OrderMapPoint,
    VenueMapPoint,
} from '@/features/orders/components/MapPanel/parts/Content/types'

export const getInitialMapCenter = (
    venue: VenueMapPoint | undefined,
    orders: OrderMapPoint[]
): MapCoordinate | undefined => venue?.coordinate ?? orders[0]?.coordinate
